type AccessPermission = 'all' | 'reneg' | 'reneg:read:debts' | 'reneg:read:agreements' | 'reneg:feature:renegociate';

const accessPermissions: AccessPermission[] = ['all', 'reneg', 'reneg:read:debts', 'reneg:read:agreements', 'reneg:feature:renegociate'];

export const routes = {
  myAgreements: {
    path: '/meus-acordos',
    type: 'private',
    name: 'Meus Acordos',
    permissionsToAccess: accessPermissions,
  },
  agreement: {
    path: '/acordo/:agreementId',
    type: 'private',
    name: 'Detalhe do Acordo',
    permissionsToAccess: accessPermissions,
  },
  agreementConditions: {
    path: '/acordo/:agreementId/condicoes',
    type: 'private',
    name: 'Condições do Acordo',
    permissionsToAccess: accessPermissions,
  },
  agreementComposition: {
    path: '/acordo/:agreementId/composicao',
    type: 'private',
    name: 'Composição do Acordo',
    permissionsToAccess: accessPermissions,
  },
  myDebts: {
    path: '/minhas-dividas',
    type: 'private',
    name: 'Minhas dívidas',
    permissionsToAccess: accessPermissions,
  },
  checkoutPaymentPrefsItau: {
    path: '/checkout/oferta/itau',
    type: 'private',
    name: 'Confirmação Itaú',
    permissionsToAccess: accessPermissions,
  },

  checkoutPaymentPrefs: {
    path: '/checkout/oferta/:creditorSlug',
    type: 'private',
    name: 'Confirmação',
    permissionsToAccess: accessPermissions,
  },
  checkoutClosedAgreement: {
    path: '/checkout/acordo-fechado/:creditorSlug',
    type: 'private',
    name: 'Acordo Fechado',
    permissionsToAccess: accessPermissions,
  },

  // billetNotFoundError: {
  //   path: '/boleto-nao-encontrado',
  //   type: 'private',
  //   name: 'Erro ao baixar o boleto',
  // },
};
